import React from 'react';
import { Constants } from '@pwc/pwc-deals-web-common';
import { useStructuredAnalysisContainer } from '../../common/hooks/useStructuredAnalysisContainer';
import StructuredAnalysisView from '../../common/StructuredAnalysisView/StructuredAnalysisView';
import '../../../common/analysis-detail-screen.scss';

const QofEContainer = () => {
  const {
    projectId,
    targetAdjustmentType,
    targetAdjustmentName,
    hasError,
    analysis,
    isConfirmVisible,
    setIsConfirmVisible,
    isLoading,
    versions,
    chartKey,
    incrementChartKey,
    viewClient,
    handleEdit,
    handleDelete,
    handleRefresh,
    workflowActions,
    isClientView,
  } = useStructuredAnalysisContainer(Constants.QUALITY_OF_EARNINGS);
  return (
    <StructuredAnalysisView
      projectId={projectId}
      documentCode={Constants.QUALITY_OF_EARNINGS}
      hasError={hasError}
      isLoading={isLoading}
      analysis={analysis}
      viewClient={viewClient}
      isClientView={isClientView}
      targetAdjustmentType={targetAdjustmentType}
      targetAdjustmentName={targetAdjustmentName}
      versions={versions}
      workflowActions={workflowActions}
      handleEdit={handleEdit}
      handleRefresh={handleRefresh}
      handleDelete={handleDelete}
      isConfirmVisible={isConfirmVisible}
      setIsConfirmVisible={setIsConfirmVisible}
      incrementChartKey={incrementChartKey}
      chartKey={chartKey}
      paneTwoVisibilityDefaultValue={false}
    />
  );
};

export default QofEContainer;
